import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { getApplicationMetadataGetApplicationMetadataQueryOptions } from "@/orval/application-metadata";
import { SiteAdminSettingsPage } from "./-components/site-admin-settings-page";

export const Route = createFileRoute("/_app/site-admin/settings")({
  loader: (loaderContext) =>
    ensureRouteQueryData(loaderContext, getApplicationMetadataGetApplicationMetadataQueryOptions()),
  component: SiteAdminSettingsPage,
});
